import Splide from '@splidejs/splide';

new Splide( '.splide',{
	type: "loop",
	perPage: 3,
	padding: "10vw",
	pagination: false,
	gap: "1rem",
	arrowPath:`M22.5,6.4c-0.4,0.5-0.4,1.3,0.1,1.8l11.3,10.4H3c-0.7,0-1.2,0.6-1.2,1.3c0,0.7,0.5,1.3,1.2,1.3h30.8L22.6,31.5
	c-0.5,0.5-0.5,1.3-0.1,1.8c0.4,0.5,1.2,0.6,1.7,0.1l13.7-12.6c0,0,0,0,0-0.1c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.2
	c0-0.1,0.1-0.1,0.1-0.1c0.1-0.2,0.1-0.3,0.1-0.5l0,0l0,0c0-0.2,0-0.3-0.1-0.5c0-0.1,0-0.1-0.1-0.1c0-0.1-0.1-0.2-0.1-0.2
	c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.1L24.1,6.2C23.6,5.8,22.9,5.8,22.5,6.4L22.5,6.4z`,
	breakpoints: {
		1400: {
			perPage: 2,
		},
		640: {
			perPage: 1,
		},
  },
}).mount();